// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_redotech-arbiter-lib-skeleton-animated-skeleton-block";
export var movingGradient = "_redotech-arbiter-lib-skeleton-moving-gradient";
export var movingGradientBlock = "_redotech-arbiter-lib-skeleton-moving-gradient-block";
export var skeleton = "_redotech-arbiter-lib-skeleton-skeleton";
export var skeletonText = "_redotech-arbiter-lib-skeleton-skeleton-text";